import { Button, CircularProgress } from "@mui/material";
import NoteAltOutlinedIcon from "@mui/icons-material/NoteAltOutlined";
import SaveAltOutlinedIcon from "@mui/icons-material/SaveAltOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import KeyIcon from "@mui/icons-material/Key";
import LinkIcon from "@mui/icons-material/Link";
import PersonIcon from '@mui/icons-material/Person';
import CallMadeIcon from '@mui/icons-material/CallMade';
import { useNavigate } from "react-router-dom";
// import OnBoardClientToDashboard from "./generateCredentialbyCrm";
import GenerateCredentailsForAll from "./GenerateCredentailforAll";
import { useState } from "react";

export function CustomSuccessButton({
  label,
  onClick,
  variant = "contained", // "contained", "outlined", "text"
  color = "primary", // "primary", "secondary", "error", "success", "info"
  size = "medium", // "small", "medium", "large"
  disabled = false,
  startIcon = null,
  endIcon = null,
  loading = false,
  sx = {}, // Custom styles
}) {
  return (
    <Button
      onClick={onClick}
      variant={variant}
      color={color}
      size={size}
      disabled={disabled || loading}
      startIcon={!loading ? startIcon : null}
      endIcon={!loading ? endIcon : null}
      sx={{
        textTransform: "none",
        minWidth: "150px",
        bgcolor: "#008F78",
        color: "#FFFFFF",
        fontWeight: "500",
        fontSize: "16px",
        py: 1.2,
        border: "1px solid #005447",
        lineHeight: "19.5px",
        "&:hover": {
          // Correct hover syntax
          bgcolor: "#009980", // Change background color
          color: "white", // Change text color
          border: "1px solid #005447",
        },
        ...sx,
      }}
    >
      {loading ? <CircularProgress size={20} sx={{ color: "white" }} /> : label}
    </Button>
  );
}

export function CustomSecondaryButton({
  label,
  onClick,
  variant = "contained", // "contained", "outlined", "text"
  color = "primary", // "primary", "secondary", "error", "success", "info"
  size = "medium", // "small", "medium", "large"
  disabled = false,
  startIcon = null,
  endIcon = null,
  loading = false,
  sx = {}, // Custom styles
}) {
  return (
    <Button
      onClick={onClick}
      variant={variant}
      color={color}
      size={size}
      disabled={disabled || loading}
      startIcon={!loading ? startIcon : null}
      endIcon={!loading ? endIcon : null}
      sx={{
        textTransform: "none",
        minWidth: "150px",
        bgcolor: "#FFFFFF",
        color: "Black",
        fontWeight: "500",
        fontSize: "16px",
        py: 1.2,
        lineHeight: "19.5px",
        border: "1px solid black",
        "&:hover": {
          // Correct hover syntax
          bgcolor: "#f2f2f2", // Change background color
          color: "black", // Change text color
          border: "1px solid black",
        },
        ...sx,
      }}
    >
      {loading ? <CircularProgress size={20} sx={{ color: "white" }} /> : label}
    </Button>
  );
}

export function CustomSecondaryDownLoadButton({
  label,
  onClick,
 
  variant = "contained", // "contained", "outlined", "text"
  color = "primary", // "primary", "secondary", "error", "success", "info"
  size = "medium", // "small", "medium", "large"
  disabled = false,
  startIcon = null,
  endIcon = null,
  loading = false,
  sx = {}, // Custom styles
}) {
  return (
    <Button
      onClick={onClick}
      variant={variant}
      color={color}
      size={size}
      disabled={disabled || loading}
      startIcon={!loading ? <SaveAltOutlinedIcon color="#313131" /> : null}
      endIcon={!loading ? endIcon : null}
      sx={{
        textTransform: "none",
        minWidth: "150px",
        bgcolor: "#F9FAFC",
        color: "#9A9A9A",
        fontWeight: "500",
        fontSize: "16px",
        lineHeight: "19.5px",
        boxShadow:"none",
        border: "1px solid #DFE3EC",
        "&:hover": {
          // Correct hover syntax
          bgcolor: "#f2f2f2", // Change background color
          color: "black", // Change text color
          border: "1px solid #DFE3EC",
        },
        ...sx,
      }}
    >
      {loading ? <CircularProgress size={20} sx={{ color: "white" }} /> : label}
    </Button>
  );
}

export function CustomSecondaryEditButton({
  label,
  onClick,
  variant = "contained", // "contained", "outlined", "text"
  color = "primary", // "primary", "secondary", "error", "success", "info"
  size = "medium", // "small", "medium", "large"
  disabled = false,
  startIcon = null,
  endIcon = null,
  loading = false,
  sx = {}, // Custom styles
}) {
  return (
    <Button
      onClick={onClick}
      variant={variant}
      color={color}
      size={size}
      disabled={disabled || loading}
      startIcon={!loading ? <NoteAltOutlinedIcon color="#313131" /> : null}
      endIcon={!loading ? endIcon : null}
      sx={{
        textTransform: "none",
        bgcolor: "#F9FAFC",
        color: "#9A9A9A",
        fontWeight: "500",
        fontSize: "16px",

        px: 1,
        lineHeight: "19.5px",

        "&:hover": {
          // Correct hover syntax
          bgcolor: "#f2f2f2", // Change background color
          color: "black", // Change text color
        },
        ...sx,
      }}
    >
      {loading ? <CircularProgress size={20} sx={{ color: "white" }} /> : label}
    </Button>
  );
}





export function GenerateCredentialsButton  ({ onClick=e=>{}, label = "Generate Credentials", sx ,data}) {
   const [open,setOpen]=useState(false);

   function handleClick(e){
    setOpen(true);
    onClick(e)
   }
  return (
   <>
   <GenerateCredentailsForAll open={open} handleClose={e=>setOpen(false)} data={data}/>
    <Button
      variant="outlined"
      startIcon={<KeyIcon />}
      sx={{
        textTransform: "none",
        borderColor: "#DFE3EC",
        bgcolor:"#F9FAFC",
        color: "black",
        fontWeight: 400,
        marginRight: 1,
        "&:hover": {bgcolor:"#DFE3EC", borderColor: "#DFE3EC",},
        ...sx, // Allow custom styles to be merged
      }}
      onClick={handleClick}
    >
      {label}
    </Button>
   </>
  );
};


export function AllocateButton  ({ onClick, label = "Allocate", sx }) {
  return (
    <Button
      variant="outlined"
      startIcon={<LinkIcon />}
      sx={{
        textTransform: "none",
        borderColor: "#DFE3EC",
        bgcolor:"#F9FAFC",
        color: "black",
        fontWeight: 400,
        marginRight: 1,
        "&:hover": {bgcolor:"#DFE3EC", borderColor: "#DFE3EC",},
        ...sx, // Allow custom styles to be merged
      }}
      onClick={onClick}
    >
      {label}
    </Button>
  );
};


export function NameAllocatedButoon  ({ onClick, label = "Empoyee1", sx }) {
  return (
    <Button
      variant="outlined"
      startIcon={<PersonIcon />}
      sx={{
        textTransform: "none",
        borderColor: "#DFE3EC",
        bgcolor:"#F9FAFC",
        color: "black",
        fontWeight: 400,
        marginRight: 1,
        "&:hover": {bgcolor:"#DFE3EC", borderColor: "#DFE3EC",},
        ...sx, // Allow custom styles to be merged
      }}
      onClick={onClick}
    >
      {label}
    </Button>
  );
};


export function GoToDashboardButton  ({ onClick, label = "Go to dashboard", sx }) {
  const navigate=useNavigate()
  function handleNavigate(){

navigate(`/dashboard/clientPortal`)

  }
  
  return (
    <Button
      variant="outlined"
      startIcon={<CallMadeIcon />}
      sx={{
        textTransform: "none",
        borderColor: "#DFE3EC",
        bgcolor:"#F9FAFC",
        color: "black",
        fontWeight: 400,
        marginRight: 1,
        "&:hover": {bgcolor:"#DFE3EC", borderColor: "#DFE3EC",},
        ...sx, // Allow custom styles to be merged
      }}
      onClick={handleNavigate}
    >
      {label}
    </Button>
  );
};

export function GoToMessageButton  ({ onClick,userId, label = "Message", sx }) {

  const navigate=useNavigate()
  function handleNavigate(){

navigate(`/dashboard/message?userId=${userId}`)

  }
  return (
    <Button
      variant="outlined"
      startIcon={<CallMadeIcon />}
      sx={{
        textTransform: "none",
        borderColor: "#DFE3EC",
        bgcolor:"#F9FAFC",
        color: "black",
        fontWeight: 400,
        marginRight: 1,
        "&:hover": {bgcolor:"#DFE3EC", borderColor: "#DFE3EC",},
        ...sx, // Allow custom styles to be merged
      }}
      onClick={handleNavigate}
    >
      {label}
    </Button>
  );
};
